import { Component, Host, h, State, Prop, Element, Listen, Fragment } from '@stencil/core';
import { TealiumSearchEvent } from '../../../utils/tealium/TealiumSearchEvent';
import getAxios from '../../../utils/get-axios';
import { geti18n } from '../../../utils/utils';
import Debounce from 'debounce-decorator';
declare var globals: any;

@Component({
  tag: 'lilu-search',
  styleUrl: 'lilu-search.scss',
  shadow: true,
})
export class LiluSearch {
  @Prop() ajaxUrl = '';
  @Prop() dataSearchUrl: string;

  @State() value = '';
  @State() category: any;
  @State() products: any;
  @State() suggestions: any;
  @State() isOpenAutocomplete: boolean;

  @Element() el: HTMLElement;

  @Debounce(350)
  private getSearchValue(searchValue: string) {
    getAxios.get(`${this.ajaxUrl}?term=${searchValue}`).then(res => {
      this.category = res.data.categories;
      this.products = res.data.products;
      this.suggestions = res.data.suggestions || this.category;

      if (this.products?.length > 0 || this.category?.length > 0) {
        this.isOpenAutocomplete = true;
      } else {
        this.isOpenAutocomplete = false;
      }
    });
  }

  componentWillLoad() {
    const queryParams = new URLSearchParams(window.location.search);
    this.value = queryParams.get('text') || '';
  }

  private defaultMobile = 3;
  private defaultDesktop = 5;


  private getMobileMaxSearchVisibleSuggestions(): number {
    return globals?.search?.searchSuggestionsMobile || this.defaultMobile;
  }
  private getMobileMaxSearchVisibleCategories(): number {
    return globals?.search?.searchCategoryMobile || this.defaultMobile;
  }
  private getMobileMaxSearchVisibleProducts(): number {
    return globals?.search?.searchProductMobile || this.defaultMobile;
  }

  private getDestopMaxSearchVisibleSuggestions(): number {
    return globals?.search?.searchSuggestionsDesktop || this.defaultDesktop;
  }
  private getDesktopMaxSearchVisibleCategories(): number {
    return globals?.search?.searchCategoryDesktop || this.defaultDesktop;
  }
  private getDestopMaxSearchVisibleProducts(): number {
    return globals?.search?.searchProductDesktop || this.defaultDesktop;
  }


  private onSubmit() {
    const form: HTMLFormElement = this.el.shadowRoot.querySelector('form');
    form?.submit();
  }

  private onFocus() {
    if (this.value.length > 1 && (this.products?.length > 0 || this.category?.length > 0)) {
      this.isOpenAutocomplete = true;
    }
  }

  /* ----------------- */
  /* Keyboard handling */
  /* ----------------- */
  private setActiveClass(item: Element, toggle = true) {
    item?.classList.toggle('current', toggle);
  }

  private selectNextItem(selectedItem: HTMLElement) {
    let nextItem = selectedItem.nextElementSibling;

    if (!nextItem) {
      nextItem = selectedItem.parentElement.nextElementSibling?.nextElementSibling?.querySelector('li');
    }

    this.setActiveClass(nextItem);
  }

  private selectPreviousItem(selectedItem: HTMLElement) {
    let previousItem = selectedItem.previousElementSibling;

    if (!previousItem) {
      previousItem = selectedItem.parentElement.previousElementSibling?.previousElementSibling?.querySelector('li:last-of-type');
    }

    this.setActiveClass(previousItem);
  }

  private onArrowUpDown(selectedItem: HTMLElement, selectAction: Function) {
    if (selectedItem) {
      selectAction(selectedItem);
    } else {
      this.setActiveClass(this.el.shadowRoot.querySelector('.list-item'));
    }
  }

  private onArrowLeftRight(selectedItem: HTMLElement, currentColumn: string, nextColumn: string) {
    if (selectedItem?.closest(currentColumn)) {
      this.setActiveClass(this.el.shadowRoot.querySelector(nextColumn));
    } else {
      this.setActiveClass(selectedItem);
    }
  }

  private onKeyDown(event: KeyboardEvent): void {
    const selectedItem: HTMLElement = this.el.shadowRoot.querySelector('.current');
    this.setActiveClass(selectedItem, false);

    if (selectedItem) {
      event.preventDefault();
    }

    switch (event.key) {
      case 'ArrowDown':
        this.onArrowUpDown(selectedItem, (item: HTMLElement) => this.selectNextItem(item));
        break;

      case 'ArrowUp':
        this.onArrowUpDown(selectedItem, (item: HTMLElement) => this.selectPreviousItem(item));
        break;

      case 'ArrowRight':
        this.onArrowLeftRight(selectedItem, '.left', '.right li');
        break;

      case 'ArrowLeft':
        this.onArrowLeftRight(selectedItem, '.right', '.left li');
        break;

      case 'Enter':
        selectedItem?.querySelector('a')?.click();
        break;

      case 'Escape':
        this.closeAutoComplete();
        break;

      default:
        break;
    }
  }

  /* ----------------- */
  /* ----------------- */

  private onInput(event) {
    if (this.value === event.target.value) {
      return;
    }

    this.value = event.target.value;
    if (this.value.length > 1) {
      this.getSearchValue(this.value);
    } else {
      this.closeAutoComplete();
    }
  }

  private closeAutoComplete() {
    this.isOpenAutocomplete = false;
  }

  private deleteInputValue() {
    this.value = '';

    document.querySelector('lilu-header').shadowRoot.querySelector('lilu-search').shadowRoot.querySelector<HTMLInputElement>('form > input').focus();
    this.closeAutoComplete();
  }

  private getFlag(item) {
    if (item.liluFlag) {
      return `<lilu-badge size="size-sm" color=${item.liluSelectiveDiscountPrice ? 'supercard-blue' : ''}>${item.liluFlag}</lilu-badge>`;
    } else if (item.configurable) {
      return `<lilu-badge size="size-sm" color="gray"><lilu-icon size='size-10 lg-size-12' color="nero" type="icon-pen-01"></lilu-icon></lilu-badge>`;
    } else {
      return '';
    }
  }

  @Listen('click', { target: 'window' })
  clickOutsideOfComponent(event) {
    // Do nothing when component receives a click inide
    if (event.composedPath().includes(this.el)) {
      return;
    }

    this.closeAutoComplete();
  }

  handleClick(searchCategorie) {
    const trackingEvent = new TealiumSearchEvent(this.value, window.location.href, searchCategorie);
    trackingEvent.executeLink();
  }

  render() {
    return (
      <Host>
        <div class="form search">
          <form action={this.dataSearchUrl} method="GET">
            <button class="search" type="submit" disabled={this.value.length <= 1}>
              <lilu-icon color="nero" type="icon-search"></lilu-icon>
            </button>
            <input
              type="text"
              autocomplete="off"
              class="input__search"
              name="text"
              maxlength="100"
              onFocus={() => this.onFocus()}
              onKeyDown={event => this.onKeyDown(event)}
              onInput={event => this.onInput(event)}
              value={this.value}
              placeholder={geti18n('search.placeholder')}
            />
            <div class={`delete ${this.value.length > 0 ? 'show' : ''}`} onClick={() => this.deleteInputValue()}>
              <lilu-icon color="nero" type="icon-closed-01"></lilu-icon>
            </div>
          </form>
        </div>
        {this.isOpenAutocomplete && (
          <div class={`search__autocomplete ${this.isOpenAutocomplete ? 'show' : ''}`}>
            <div class="left">
              {this.suggestions && (
                <Fragment>
                  <h2 class={`title`}> {geti18n('search.suggestionstitle')}</h2>
                  <ul>
                    {this.suggestions?.slice(0, this.getDestopMaxSearchVisibleSuggestions()).map((item: any = {}, index) => (
                      <li class={`category-item ${index >= this.getMobileMaxSearchVisibleSuggestions() ? 'hideOnMobile' : ''}`}>
                        <a href={`${item.url}`} onClick={() => this.handleClick('category')}>
                          <div class="item">
                            <span>
                              {item.term} {item.productsCount && `(${item.productsCount})`}
                            </span>
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </Fragment>
              )}
              <h2 class={`title`}> {geti18n('search.categoriestitle')}</h2>
              <ul>
                {this.category?.slice(0, this.getDesktopMaxSearchVisibleCategories()).map((item: any = {}, index) => (
                  <li class={`category-item ${index >= this.getMobileMaxSearchVisibleCategories() ? 'hideOnMobile' : ''}`}>
                    <a href={`${item.url}`} onClick={() => this.handleClick('category')}>
                      <div class="item">
                        <span>
                          {item.term} {item.productsCount && `(${item.productsCount})`}
                        </span>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div class="right">
              <h2 class={`title`}> {geti18n('search.productstitle')}</h2>
              <ul>
                {this.products?.slice(0, this.getDestopMaxSearchVisibleProducts()).map((item: any = {}, index) => (
                  <li class={`list-item ${index >= this.getMobileMaxSearchVisibleProducts() ? 'hideOnMobile' : ''} `}>
                  <a href={`${item.url}`} onClick={() => this.handleClick('product')}>
                      <div class="item">
                        {item.images && (
                          	<div class="item-img">
                            	<img loading="lazy" src={`${item.images[0].url}`} alt="alt" />
                          	</div>
                        	)}
                        	<div class="item-text">
                          	<div class="item-title">{item.name}</div>
                          	{item.price && (
                            	<lilu-price
                              	type={item.liluhitprice ? 'hit' : 'normal'}
                              	size="size-sm"
                            	>
                              	{`${item.price.currencyIso} ${item.price.formattedValue}`}
                            	</lilu-price>
                          	)}
                        </div>
                        <div class="item-flag" innerHTML={`${this.getFlag(item)}`}></div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
              <div class="text-right" onClick={() => this.onSubmit()}>
                {geti18n('search.showMore')} &#x3e;
              </div>
            </div>
          </div>
        )}
      </Host>
    );
  }
}
